import Cookies from 'js-cookie'

const TokenKey = 'accessToken';

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setUserInfo(data) {
  return Cookies.set("publicSecurityAdminUser", data)
}

export function getUserInfo() {
  return Cookies.get("publicSecurityAdminUser")
}

export function removeUserInfo() {
  return Cookies.remove("publicSecurityAdminUser")
}

export function getRoles() {
  return JSON.parse(Cookies.get("publicSecurityAdminUser")).content;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js